import { assign } from 'lodash-es';

export interface BaseState {
  filterObj?: object;
}

export const baseReducers = <T extends BaseState>() => ({
  setState: (state: T, newState: Partial<T> | undefined) => {
    if (newState) {
      assign(state, newState);
    }
    return state;
  },

  setFilter: (state: T, filter: T['filterObj']) => {
    if (!state.filterObj) {
      state.filterObj = {};
    }

    state.filterObj = filter;
    return state;
  },

  clearFilter: (state: T) => {
    state.filterObj = {};
    return state;
  },
});
